export const MxSellerProtection = () => (
  <svg
    width="48"
    height="56"
    viewBox="0 0 48 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.8253 0.5L1.53671 4.21861C1.17675 4.27879 0.850187 4.46589 0.616271 4.74603C0.382354 5.02617 0.25652 5.38083 0.261516 5.74575V31.7759C0.246161 31.8848 0.246161 31.9953 0.261516 32.1042C0.696751 34.0208 5.20941 51.789 23.7871 55.5C42.3571 51.7814 46.8775 34.0208 47.3127 32.1042C47.3245 31.9951 47.3245 31.885 47.3127 31.7759V4.42476L23.8253 0.5ZM23.8253 2.02714L45.8467 5.69991V31.7224C45.4114 33.6161 41.1507 50.2466 23.8024 53.866C6.46168 50.2161 2.20097 33.5855 1.77337 31.7224V5.72284L23.8253 2.02714Z"
      fill="black"
      stroke="black"
      strokeWidth="0.5"
    />
    <path
      d="M40.4871 29.2569H8.03534C7.71335 29.2569 7.40457 29.129 7.17688 28.9013C6.9492 28.6736 6.82129 28.3648 6.82129 28.0428V21.7434C6.82129 21.4214 6.9492 21.1126 7.17688 20.8849C7.40457 20.6572 7.71335 20.5293 8.03534 20.5293H40.4871C40.8091 20.5293 41.118 20.6572 41.3456 20.8849C41.5733 21.1126 41.7012 21.4214 41.7012 21.7434V28.0428C41.7012 28.3648 41.5733 28.6736 41.3456 28.9013C41.118 29.129 40.8091 29.2569 40.4871 29.2569Z"
      fill="#C41719"
    />
    <path
      d="M40.4871 29.2569H8.03534C7.71335 29.2569 7.40457 29.129 7.17688 28.9013C6.9492 28.6736 6.82129 28.3648 6.82129 28.0428V21.7434C6.82129 21.4214 6.9492 21.1126 7.17688 20.8849C7.40457 20.6572 7.71335 20.5293 8.03534 20.5293H40.4871C40.8091 20.5293 41.118 20.6572 41.3456 20.8849C41.5733 21.1126 41.7012 21.4214 41.7012 21.7434V28.0428C41.7012 28.3648 41.5733 28.6736 41.3456 28.9013C41.118 29.129 40.8091 29.2569 40.4871 29.2569V29.2569Z"
      stroke="black"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M20.7018 21.5449L19.3809 26.1416H20.5033L21.7861 21.5449H20.7018Z"
      fill="white"
    />
    <path
      d="M23.6034 21.5526L22.3359 22.9499L21.893 21.5449L21.4043 23.1866L21.7785 24.8283L23.13 23.1942L23.6034 21.5526Z"
      fill="white"
    />
    <path
      d="M23.4965 26.1475L24.8022 21.5508H23.6797L22.374 26.1475H23.4965Z"
      fill="white"
    />
    <path
      d="M25.9862 26.1551H27.2614L26.6887 23.7117L28.4678 21.5584H27.4064L26.452 22.7343L26.1847 21.5584L24.9172 21.5508L25.4517 23.8568L22.0156 27.9419H23.0999L25.6884 24.8952L25.9862 26.1551Z"
      fill="white"
    />
    <path
      d="M24.726 26.416H24.5351L24.2373 27.4774H24.9245L24.9627 27.317L24.4664 27.3094L24.726 26.416Z"
      fill="white"
    />
    <path
      d="M25.5657 27.2254L25.4817 27.3018H25.2373L25.1839 27.2407L25.3519 26.6604L25.4358 26.5916H25.6649L25.726 26.6604L25.5657 27.2254ZM25.8023 26.416H25.4053L25.1839 26.584L24.9854 27.3476L25.1151 27.5232H25.5045L25.7336 27.34L25.9322 26.6298L25.8023 26.416Z"
      fill="white"
    />
    <path
      d="M26.3991 27.0881L26.361 27.2485L26.277 27.3019H26.0555L26.0097 27.2256L26.1624 26.6758L26.2617 26.5995H26.4831L26.5213 26.6682L26.4908 26.798H26.6817L26.7351 26.5766L26.6129 26.4238H26.2311L25.9944 26.5995L25.7959 27.2943L25.941 27.4852H26.3075L26.5366 27.3096L26.59 27.0881H26.3991Z"
      fill="white"
    />
    <path
      d="M27.6207 26.4238H27.4146L26.9335 26.8514L27.0481 26.4238H26.8572L26.5518 27.4852L26.7579 27.4928L26.8648 27.1187L27.0404 26.9583L27.1397 27.4928H27.3306L27.1931 26.8133L27.6207 26.4238Z"
      fill="white"
    />
    <path
      d="M27.719 27.0041H28.0702L28.1084 26.8591H27.7495L27.8182 26.5995H28.3374L28.3833 26.4238H27.6961L27.3906 27.4928H28.0855L28.1313 27.3172H27.6273L27.719 27.0041Z"
      fill="white"
    />
    <path
      d="M28.521 26.8821L28.5973 26.6072H28.8722L28.918 26.6531L28.8798 26.821L28.8035 26.8898L28.521 26.8821ZM29.0478 26.8821L29.1241 26.5843L29.0173 26.4316H28.4675L28.1621 27.5006H28.3454L28.4675 27.0501H28.5973L28.6736 27.5006H28.8645L28.7806 27.0501H28.8341L29.0478 26.8821Z"
      fill="white"
    />
  </svg>
);
